import React, { useEffect, useState } from "react";
import { Table, Button, Space, Tag, Modal, message } from "antd";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import authApi from "../../../api/authApi";

const CAMP_COLORS = { shopee: "orange", lazada: "blue", tiktok: "default" };
const CAMP_LABELS = { shopee: "Shopee", lazada: "Lazada", tiktok: "TikTok" };

/** Format unix seconds to DD/MM/YYYY HH:mm:ss or dash */
function fmtUnix(ts) {
    if (!ts && ts !== 0) return "—";
    return dayjs.unix(Number(ts)).format("DD/MM/YYYY HH:mm:ss");
}

function PromoList() {
    const navigate = useNavigate();
    const [promos, setPromos] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchPromos = async () => {
        setLoading(true);
        try {
            const { data } = await authApi.getPromos();
            setPromos(data.promos || []);
        } catch {
            message.error("Không thể tải danh sách chiến dịch X2");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchPromos(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleDelete = (record) => {
        Modal.confirm({
            title: "Xoá chiến dịch?",
            content: `Bạn có chắc muốn xoá chiến dịch "${record.name}"?`,
            okText: "Xoá",
            okButtonProps: { danger: true },
            cancelText: "Huỷ",
            onOk: async () => {
                try {
                    await authApi.deletePromo(record.id);
                    message.success("Đã xoá chiến dịch");
                    fetchPromos();
                } catch {
                    message.error("Xoá thất bại");
                }
            },
        });
    };

    const columns = [
        {
            title: "ID", dataIndex: "id", key: "id", width: 60,
        },
        {
            title: "Tên", dataIndex: "name", key: "name", ellipsis: true,
        },
        {
            title: "Sàn", dataIndex: "campId", key: "campId", width: 100,
            render: (v) => (
                <Tag color={CAMP_COLORS[v] || "default"}>
                    {CAMP_LABELS[v] || v?.toUpperCase()}
                </Tag>
            ),
        },
        {
            title: "Hệ số ×", dataIndex: "multiplier", key: "multiplier",
            width: 90, align: "center",
            render: (v) => <span className="font-semibold">{Number(v)} ×</span>,
        },
        {
            title: "Bật/Tắt", dataIndex: "enabled", key: "enabled",
            width: 90, align: "center",
            render: (v) => (
                <Tag color={v ? "green" : "default"}>{v ? "BẬT" : "Tắt"}</Tag>
            ),
        },
        {
            title: "Cửa sổ thời gian", key: "window",
            width: 340,
            render: (_, r) => (
                <span className="text-content-3">
                    {fmtUnix(r.startTime)} → {fmtUnix(r.endTime)}
                </span>
            ),
        },
        {
            title: "Hành động", key: "action", width: 140, fixed: "right",
            render: (_, record) => (
                <Space>
                    <Button
                        size="small"
                        icon={<FontAwesomeIcon icon={faEdit} />}
                        onClick={() => navigate(`/app-rate-promo/${record.id}/edit`)}
                    >
                        Sửa
                    </Button>
                    <Button
                        size="small"
                        danger
                        icon={<FontAwesomeIcon icon={faTrash} />}
                        onClick={() => handleDelete(record)}
                    >
                        Xoá
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div className="flex-1 flex flex-col p-5 overflow-auto gap-4">
            <div className="flex items-center justify-between">
                <h1 className="text-xl font-bold">Chiến dịch X2 / X3 Cashback</h1>
                <Button
                    type="primary"
                    icon={<FontAwesomeIcon icon={faPlus} />}
                    onClick={() => navigate("/app-rate-promo/create")}
                >
                    Tạo mới
                </Button>
            </div>

            <p className="text-sm text-content-3 -mt-2">
                Cấu hình bội số hoàn tiền (X2, X3…) theo sàn và khoảng thời gian đặt hàng.
            </p>

            <div className="bg-surface border border-line rounded-lg shadow-sm">
                <Table
                    size="small"
                    dataSource={promos}
                    rowKey="id"
                    columns={columns}
                    pagination={false}
                    loading={loading}
                    scroll={{ x: "max-content" }}
                />
            </div>
        </div>
    );
}

export default PromoList;
